<template>
  <div class="d-none" aria-hidden="true"></div>
</template>

<script>
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {changeIdOfComponentJson} from "@/store/Modules/Site";

export default {
  name: "LoadProjectTemplate",
  methods: {
    async pasteTemplate() {
      let layer = await navigator.clipboard.readText();
      try {
        // چون فقط یکبار stringify شده، یکبار هم parse کافیه
        layer = JSON.parse(layer);
        await this.$store.dispatch('Site/setSite', layer['site']);
        await this.$store.commit('Site/setGlobalStyle', layer['global_style']);
      } catch (e) {
        toast('متن کپی شده معتبر نمیباشد.', 'متن کپی شده معتبر نمیباشد.', 'danger');
        console.log('Past Error => ', e);
        return false;
      }
    }
  }
}
</script>

<style scoped>

</style>